import { z } from 'zod/v4'

const ColumnSchema = z
  .object({
    width: z.union([z.number(), z.string()]).optional(),
    model: z.string().optional(),
    field: z
      .string()
      .describe(
        'the field handle of the field matched against viewable fields',
      ),
  })
  .passthrough()

export const SpreadsheetColumnSchema = ColumnSchema

export type SpreadsheetColumn = z.infer<typeof SpreadsheetColumnSchema>

export const SpreadsheetConfigSchema = z.object({
  columns: z.array(SpreadsheetColumnSchema),
})

export type SpreadsheetConfig = z.infer<typeof SpreadsheetConfigSchema>
